import { createListenerMiddleware } from '@reduxjs/toolkit';
import { cartHydrated, loadCartState } from '@/entities/cart';
import { baseApi } from '@/shared/api/baseApi';
import {
  credentialsUpdated,
  currentStoreChanged,
  sessionCleared,
} from '@/shared/lib/redux/actions';
import type { RootStateShape } from '@/shared/lib/redux/rootStateShape';

/** Switching the active store (or signing out) invalidates every per-store RTK Query cache entry
 *  — otherwise a screen could briefly render the previous store's data under the new store's
 *  X-Store-Id (docs/PLAN.md §6 "переключение магазина → resetApiState"). */
export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: currentStoreChanged,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});

listenerMiddleware.startListening({
  actionCreator: sessionCleared,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});

// The carts belong to a user: when a different account signs in (or the same one after an expired
// session) that account's persisted carts are loaded. Token refreshes for the same user are no-ops.
listenerMiddleware.startListening({
  actionCreator: credentialsUpdated,
  effect: (action, api) => {
    const previousUserId = (api.getOriginalState() as RootStateShape).auth.user?.id ?? null;
    const userId = action.payload.user.id;
    if (previousUserId !== userId) api.dispatch(cartHydrated(loadCartState(userId)));
  },
});
